import axios from 'axios';
import * as yup from 'yup';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
});
export async function postStickyNotes({ patientId, content, }) {
    const response = await axios.post('/api/postStickyNotes', {
        patient_id: patientId,
        note_content: content,
    });
    const { message } = await responseSchema.validate(response.data);
    return {
        message,
    };
}
